<!-- =========================================================================================
  File Name: ECommerceItemDetail.vue
  Description: eCommerce Item Detail page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="mt-4 p-2 sm:p-8">
    <vx-card class="flex flex-col mx-auto mb-8" v-if="item_data">
      <div class="absolute top-0 right-0">
        <vs-icon icon="cancel" class="m-4 cursor-pointer text-danger" size="large" @click="$router.push({name: 'category-view'}).catch(err => {})"/>
      </div>

<!--      <template slot="no-body">-->

<!--        <div class="item-content">-->

          <!-- Item Main Info -->
<!--          <div class="product-details p-6">-->
            <div class="vx-row flex-1 mt-6">
              <div class="vx-col lg:w-2/5 w-full flex items-start justify-center">
                <image-magnifier class="hidden lg:flex" :src="getImage(item_data, imageHeight)" :zoom-src="getImage(item_data, imageHeight * 2)" :height="imageHeight" :zoom-width="imageHeight * 1.5" :zoom-height="imageHeight * 1.25"/>
                <img :src="getImage(item_data, imageHeight)" :alt="item_data.name" class="flex lg:hidden mx-auto" rel="preload">
<!--
                  <cld-image
                    :cloudName="cloudName"
                    :publicId="`products/${item_data.id}`"
                    :height="imageHeight"
                    width="auto"
                    class="flex lg:hidden mx-auto"
                  />
-->
<!--                </div>-->
              </div>

              <!-- Item Content -->
              <div class="vx-col lg:w-3/5 w-full">

                <h3>{{ item_data.name }}</h3>

                <p class="flex items-center flex-wrap">
                  <span class="text-2xl leading-none font-medium text-primary mr-4 mt-2">Q{{ getPrice(item_data).toFixed(2) }}</span>
                </p>

                <vs-divider/>

                <p>{{ item_data.description }}</p>

                <vs-divider v-if="hasSlices"/>

                <div class="vx-row flex justify-center" v-if="hasSlices">
                  <div>
                    Porciones: {{ item_data.slices }}
                  </div>
                </div>

                <vs-divider v-if="hasSlices"/>

                <!-- Quantity -->
                <div class="vx-row">

                  <div class="vx-col w-full">
                    <p class="my-2" v-if="selectedStore == null">
                      <span class="text-danger">Selecciona una tienda para conocer la diponibilidad de este producto</span>
                    </p>
                    <div class="my-2" v-else>
                      <vs-input-number :min="0" :max="maxSaleQty" :value="quantity" @input="updateItemQuantity($event)" class="inline-flex"/>
                      <p>
                        <span class="text-success" v-if="available">Disponible en {{ selectedStore.name }}</span>
                        <span class="text-danger" v-else>Lo sentimos, no tenemos disponibildad de este producto en {{ selectedStore.name }}</span>
                      </p>
                    </div>
                  </div>

                  <div class="vx-col w-full">
                    <div class="flex flex-wrap items-start mb-4">

                      <!-- Add To Cart Button -->
                      <vs-button
                        class="mr-4 mb-4"
                        icon-pack="feather"
                        icon="icon-shopping-cart"
                        v-if="!isInCart(item_data.id) && item_data.status == 'ACT' && available"
                        @click="toggleItemInCart(item_data)">
                        AGREGAR
                      </vs-button>

                      <vs-button
                        v-if="isInCart(item_data.id)"
                        class="mr-4 mb-4"
                        icon-pack="feather"
                        icon="icon-shopping-cart"
                        color="success"
                        @click="$router.push({name: 'checkout'}).catch(err => {})">
                        VER EN CARRITO
                      </vs-button>
                      <!-- /Add To Cart Button -->

                    </div>
                  </div>
                </div>

                <vs-divider v-if="variations.length > 0"/>
                  <h5>También puedes celebrar con:</h5>
                <div class="vx-row flex justify-center lg:justify-start" v-if="variations.length > 0">
                  <vx-card class="m-2 w-full sm:w-1/3 md:w-1/4 xl:w-1/5 flex justify-center items-center cursor-pointer" v-for="item in variations" :key="item.id" @click="navigate_to_detail_view(item)">
                    <div class="flex flex-col justify-center items-center text-center text-xs mb-2 h-8">
                      {{ item.name }}
                    </div>
                    <img :src="getImage(item, 80)" :alt="item.name" class="mx-auto" rel="preload">
<!--
                    <cld-image
                      cloudName="anfora"
                      :publicId="`products/${item.id}.png`"
                      height="80"
                      width="auto"
                      class="mx-auto"
                    />
-->
                    <div class="flex flex-col justify-center items-center mt-2">
                      Q{{ getPrice(item).toFixed(2) }}
                    </div>
                  </vx-card>
                </div>

                <!-- /Quantity -->

                <!-- Social links -->
                <!--                <div class="vx-row">-->
                <!--                  <div class="vx-col flex flex-wrap items-center">-->
                <!--                    <vs-button class="mr-4" type="border" icon-pack="feather" color="#1551b1" icon="icon-facebook" radius></vs-button>-->
                <!--                    <vs-button class="mr-4" type="border" icon-pack="feather" color="#00aaff" icon="icon-twitter" radius></vs-button>-->
                <!--                    <vs-button class="mr-4" type="border" icon-pack="feather" color="#c4302b" icon="icon-youtube" radius></vs-button>-->
                <!--                    <vs-button class="mr-4" type="border" icon-pack="feather" color="#405DE6" icon="icon-instagram" radius></vs-button>-->
                <!--                  </div>-->
                <!--                </div>-->

              </div>

<!--            </div>-->
<!--          </div>-->

          <!--
                     Product Feature/Meta Row
                              <div class="py-24 mb-16 mt-10 text-center item-features">
                                <div class="vx-row">
                                  <div class="vx-col md:w-1/3 w-full">
                                    <div class="w-64 mx-auto mb-16 md:mb-0">
                                      <feather-icon icon="AwardIcon" svgClasses="h-12 w-12 text-primary stroke-current" class="block mb-4" />
                                      <span class="font-semibold text-lg">100% Original</span>
                                      <p class="mt-2">Chocolate bar candy canes ice cream toffee cookie halvah.</p>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/3 w-full">
                                    <div class="w-64 mx-auto mb-16 md:mb-0">
                                      <feather-icon icon="ClockIcon" svgClasses="h-12 w-12 text-primary stroke-current" class="block mb-4" />
                                      <span class="font-semibold text-lg">10 Day Replacement</span>
                                      <p class="mt-2">Marshmallow biscuit donut dragée fruitcake wafer.</p>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/3 w-full">
                                    <div class="w-64 mx-auto">
                                      <feather-icon icon="ShieldIcon" svgClasses="h-12 w-12 text-primary stroke-current" class="block mb-4" />
                                      <span class="font-semibold text-lg">1 Year Warranty</span>
                                      <p class="mt-2">Cotton candy gingerbread cake I love sugar sweet.</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
          -->

        </div>

        <!-- Related Products -->
        <!--
                <div v-if="hasRelated" class="related-products text-center flex flex-col items-center justify-center px-10 mt-4 max-w-sm md:max-w-xl mx-8 lg:max-w-3xl xl:max-w-4xl">

                  <div class="related-headings mb-8 text-center">
                    <h3 class="uppercase">Productos relacionados</h3>
                    <p>Otros productos que le pueden interesar</p>
                  </div>
                  <carousel
                    :autoplay="false"
                    :loop="true"
                    :perPage="1"
                    :perPageCustom="[[768, 2],[992, 3], [1200, 4], [1600, 5]]"
                    :paginationEnabled="false"
                    :navigationEnabled="true"
                    class="related-product-swiper"
                  >
                    <slide v-for="item in related_items" :key="item.id" class="p-4">
                      <vx-card class="overflow min-w-32 md:min-w-64">

                        &lt;!&ndash; Item Heading &ndash;&gt;
                        <div class="item-heading mb-4">
                          <p class="text-lg font-semibold truncate">{{ item.name }}</p>
                          &lt;!&ndash;                <p class="text-sm">&ndash;&gt;
                          &lt;!&ndash;                  <span class="mr-2">by</span>&ndash;&gt;
                          &lt;!&ndash;                  <span>{{ item.brand }}</span>&ndash;&gt;
                          &lt;!&ndash;                </p>&ndash;&gt;
                        </div>

                        &lt;!&ndash; Item Image &ndash;&gt;
                        <div class="img-container w-32 mx-auto my-base">
                          &lt;!&ndash;                <img class="responsive" :src="getImage(item)" :alt="item.name">&ndash;&gt;
                          <cld-image
                            cloudName="anfora"
                            :publicId="`products/${item.code}.png`"
                            height="110"
                            dpr="auto"
                            width="auto"
                            crop="scale"
                            class="mx-auto"
                          />
                        </div>

                        &lt;!&ndash; Item Meta &ndash;&gt;
                        <div class="item-meta">
                          <star-rating :show-rating="false" :rating="item.rating" :star-size="14" class="justify-center" read-only/>
                          <p class="text-lg font-medium text-primary">Q{{ item.price }}</p>
                          <div class="mt-2 justify-center flex">
                            <vs-button
                              icon-pack="feather"
                              icon="icon-search"
                              @click="navigate_to_detail_view(item)"
                            >
                              VER
                            </vs-button>
                          </div>
                        </div>
                      </vx-card>
                    </slide>
                  </carousel>
                </div>
        -->

<!--      </template>-->
    </vx-card>
  </div>
</template>

<script>
  import {Carousel, Slide} from 'vue-carousel';
  import StarRating from 'vue-star-rating'
  // import {CldImage} from 'cloudinary-vue';
  import {ImageMagnifier} from 'vue-image-magnifier';

  export default {
    components: {
      Carousel,
      Slide,
      StarRating,
      // CldImage,
      ImageMagnifier
      // Header: () => import('./components/Header'),
    },
    data() {
      return {
        item_data: null,
        available: false,
        quantity: 1,
        updateCart: false,
        error_occured: false,
        error_msg: '',

        // Related Products Swiper
        swiperOption: {
          slidesPerView: 4,
          spaceBetween: 55,
          // breakpoints: {
          //   1600: {
          //     slidesPerView: 4,
          //     spaceBetween: 55
          //   },
          //   1300: {
          //     slidesPerView: 3,
          //     spaceBetween: 55
          //   },
          //   900: {
          //     slidesPerView: 2,
          //     spaceBetween: 55
          //   },
          //   640: {
          //     slidesPerView: 1,
          //     spaceBetween: 55
          //   }
          // },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },

        // Below is data which is common in any item
        // Algolia's dataSet don't provide this kind of data. So, here's dummy data for demo
        available_item_colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
        opt_color: '#7367F0',
        is_hearted: false,

        related_items: [{id: 1}, {id: 4}, {id: 7}, {id: 10}, {id: 13}]
      }
    },
    computed: {
      windowWidth() {
        return this.$store.state.windowWidth;
      },
      imageHeight() {
        if (this.windowWidth < 400) {
          return 200;
        } else if (this.windowWidth < 600) {
          return 250;
        } else {
          return 350;
        }
      },
      imageWidth() {
        if (this.windowWidth < 400) {
          return 150;
        } else if (this.windowWidth < 600) {
          return 190;
        } else {
          return 300;
        }
      },
/*
      cloudName() {
        return this.$store.getters['getParameter']('cloudinary').cloudName;
      },
*/
      imagesURL() {
        return this.$store.getters['getParameter']('images').baseURL;
      },
      pixel() {
        return this.$store.getters['getParameter']('pixel');
      },
      stockAPI() {
        return this.$store.getters['getParameter']('stock').stockAPI;
      },
      productGroups() {
        return this.$store.state.productGroups.list;
      },
      item_qty() {
        const item = this.$store.getters['eCommerce/getCartItem'](this.item_data.id);
        return Object.keys(item).length ? item.quantity : 1
      },
      cartItems() {
        return this.$store.state.eCommerce.cartItems.slice().reverse()
      },
      itemColor() {
        return (obj) => {
          const style_obj = {}

          obj.style.forEach(p => {
            style_obj[p] = obj.color
          });

          return style_obj;
        }
      },
      isInCart() {
        return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
      },
      hasRelated() {
        return (this.item_data.hasOwnProperty('relatedProducts') && this.item_data.relatedProducts.length > 0);
      },
      variations() {
        if (this.item_data.hasOwnProperty('variations')) {
          return this.$store.getters.products.filter(item => this.item_data.variations.split(',').includes(item.id.toString()));
        } else {
          return [];
        }
      },
      selectedStore() {
        return this.$store.state.selectedStore;
      },
      hasSlices() {
        return this.item_data.hasOwnProperty('slices');
      },
      maxSaleQty() {
        let qty = 0;
        if (this.item_data.hasOwnProperty('maxSaleQty')) {
          qty = this.item_data.maxSaleQty;
        }
        return qty;
      }
    },
    watch: {
      // call again the method if the route changes
      '$route': function () {
        this.fetch_item_details(this.$route.params.item);
      }
    },
    methods: {
      toggleItemInCart(item) {
        // eslint-disable-next-line
        const product = structuredClone(item);
        product.price = this.getPrice(item);
        this.$store.dispatch('eCommerce/toggleItemInCart', {...product, cartQuantity: this.quantity, productGroups: this.productGroups});
        window.fbq('track', 'AddToCart');
      },
      getStockPixel() {
        var self = this;
        this.$http.post(this.pixel.stockAPI + '/v1/pixel/get_stock', {
          ip: this.selectedStore.ipAddress,
          port: this.selectedStore.port,
          user: this.pixel.user,
          password: this.pixel.password,
          code: this.item_data.code
        }).then(response => {
          if (response.data) {
            self.available = (response.data.stock > self.quantity);
          } else {
            self.available = false;
          }
        }).catch(() => {
          self.available = false;
        })
      },
      getStock() {
        if (this.item_data.hasOwnProperty('stockId')) {
          if (this.selectedStore.application == 'PIXEL') {
            const self = this;
            this.$http.post(`${this.stockAPI}/stock/product`, {
              storeID: this.selectedStore.stockId,
              productID: parseInt(this.item_data.stockId)
            }).then(response => {
              if (response.data) {
                self.available = (response.data.data[0].stock > self.quantity);
              } else {
                self.available = false;
              }
              if (self.available) {
                if (self.updateCart) {
                  // eslint-disable-next-line
                  const product = structuredClone(self.item_data);
                  product.price = this.getPrice(self.item_data);
                  if (self.isInCart(product.id)) {
                    const itemIndex = self.cartItems.findIndex(item => item.id == product.id);
                    if (itemIndex >= 0) {
                      this.$store.dispatch('eCommerce/updateItemQuantity', {quantity: self.quantity, index: itemIndex, productGroups: this.productGroups})
                    }
                  } else {
                    self.toggleItemInCart(product);
                  }
                }
              }
              self.updateCart = false;
            }).catch(() => {
              self.available = false;
              self.updateCart = false;
            })
          } else if (this.selectedStore.application == 'PULSE') {
            const self = this;
            this.$http.post(`${this.stockAPI}/stock/pulse`, {
              storeId: this.selectedStore.stockId,
              productId: this.item_data.pulseStockId
            }).then(response => {
              self.available = false;
              if (response) {
                if (response.data) {
                  if (response.data != null) {
                    self.available = (response.data.data.stock > self.quantity);
                  }
                }
              }
              if (self.available) {
                if (self.updateCart) {
                  // eslint-disable-next-line
                  const product = structuredClone(self.item_data);
                  product.price = this.getPrice(self.item_data);
                  if (self.isInCart(product.id)) {
                    const itemIndex = self.cartItems.findIndex(item => item.id == product.id);
                    if (itemIndex >= 0) {
                      this.$store.dispatch('eCommerce/updateItemQuantity', {quantity: self.quantity, index: itemIndex, productGroups: this.productGroups})
                    }
                  } else {
                    self.toggleItemInCart(product);
                  }
                }
              }
              self.updateCart = false;
            }).catch(() => {
              self.available = false;
              self.updateCart = false;
            })
          }
        } else {
          this.available = false;
          this.updateCart = false;
        }
      },

      fetchItemDetails(id) {
        const self = this;
        if (this.$store.getters.products.length > 0) {
          this.loadItem(id);
        } else {
          setTimeout(function () {
            if (self.$store.getters.products.length > 0) {
              self.loadItem(id);
            } else {
              setTimeout(function () {
                self.loadItem(id);
              }, 500);
            }
          }, 500);
        }
      },

      loadItem(id) {
        let item;
        if (/\d/.test(id)) {
          item = this.$store.getters['products'].filter(item => item.id == id);
        } else {
          item = this.$store.getters['products'].filter(item => item.name.CIAI().toLowerCase().replace(/ /g, '-') == id);
        }
        if (item.length > 0) {
          this.item_data = item[0];
          if (this.selectedStore != null) {
            if (this.selectedStore.ipAddress != '') {
              this.quantity = this.item_qty;
              this.getStock();
            }
          }
        } else {
          this.$store.dispatch('updateHomeScreen', 2);
          this.$router.push('/');
        }
      },

      fetch_item_details(id) {
        // var item = this.$store.state.products.filter(item => item.id == item_id);
        let item;
        if (/\d/.test(id)) {
          item = this.$store.getters['products'].filter(item => item.id == id);
        } else {
          item = this.$store.getters['products'].filter(item => item.name.CIAI().toLowerCase().replace(/ /g, '-') == id);
        }
        if (item.length > 0) {
          this.item_data = item[0];
          if (this.selectedStore != null) {
            if (this.selectedStore.ipAddress != '') {
              this.quantity = this.item_qty;
              this.getStock();
            }
          }
        } else {
          this.$store.dispatch('updateHomeScreen', 2);
          this.$router.push('/');
        }
      },
      getPrice(item) {
        let price = item.price;
        if (this.selectedStore != null) {
          if ('priceList' in this.selectedStore) {
            if (this.selectedStore.priceList == 3) {
              price = item.price3;
            }
          }
        }
        return price;
      },
/*
      getImage(product, height) {
        return `https://res.cloudinary.com/${this.cloudName}/image/upload/dpr_auto,h_${height},w_auto,c_scale/products/${product.id}`;
      },
*/
      getImage(item, height) {
        const imageURL = [this.imagesURL, '/products%2F', item.id, '@', height, '.jpg?alt=media'].join('');
        return imageURL;
      },
      updateItemQuantity(event) {
        this.quantity = event;
        this.updateCart = this.isInCart(this.item_data.id);
        if (this.quantity <= 0) {
          this.quantity = 0;
          if (this.updateCart) {
            this.toggleItemInCart(this.item_data);
          }
        } else {
          this.getStock();
        }
      },
      navigate_to_detail_view(item) {
        // this.$router.push({name: 'item-detail-view', params: {item: item.name.toLowerCase().replace(/ /g, '-')}}).catch(() => {
        // });
        const category = this.$store.getters.getCategory(item.categories.split(',')[0]).name.CIAI().toLowerCase().replace(/ /g, '-');
        this.$router.push({
          name: 'item-detail-view',
          params: {
            category: category,
            item: item.name.CIAI().toLowerCase().replace(/ /g, '-')
          }
        }).catch(() => { });
        // this.fetch_item_details(item);
      }
    },
    mounted() {
      this.fetchItemDetails(this.$route.params.item);
    },
    created() {
      window._this = this;
      // var product = null;
      // this.fetch_item_details(this.$route.params.item);
      // for (var i = 0; i < this.related_items.length; i++) {
      //   product = this.$store.state.products.filter(item => item.id == this.related_items[i].id);
      //   if (product) {
      //     this.related_items[i].code = product[0].code;
      //     this.related_items[i].name = product[0].name;
      //     this.related_items[i].price = product[0].price;
      //   }
      // }
    }
  }
</script>

<!--
<style lang="scss">

  @import "@/assets/scss/vuexy/_variables.scss";

  #item-detail-page {
    .color-radio {
      height: 2.28rem;
      width: 2.28rem;

      > div {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .item-features {
      background-color: #f7f7f7;

      .theme-dark & {
        background-color: $theme-dark-secondary-bg;
      }
    }

    .product-sales-meta-list {
      .vs-list&#45;&#45;icon {
        padding-left: 0;
      }
    }

    .related-product-swiper {
      // padding-right: 2rem;
      // padding-left: 2rem;

      .swiper-wrapper {
        padding-bottom: 2rem;

        > .swiper-slide {
          background-color: #f7f7f7;
          box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1), 0 5px 12px 0 rgba(0, 0, 0, 0.08) !important;

          .theme-dark & {
            background-color: $theme-light-dark-bg;
          }
        }
      }

      .swiper-button-next,
      .swiper-button-prev {
        transform: scale(.5);
        filter: hue-rotate(40deg);
      }

      .swiper-button-next {
        right: 0
      }

      .swiper-button-prev {
        left: 0;
      }
    }
  }
</style>
-->
